"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../../composite/table/table-cells");
const authored_columns_1 = require("../../../../composite/evidence-2/authored-evidence/authored-columns");
function useColumns() {
    const intl = react_intl_1.useIntl();
    const { authoredColumns } = authored_columns_1.useAuthoredColumns();
    return [
        {
            datakey: 'service',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_SERVICE',
                defaultMessage: 'Služba',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'localPart',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_LOCAL_PART',
                defaultMessage: 'Operace',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'duration',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_DURATION',
                defaultMessage: 'Trvání',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.NumberCell,
            sortable: true,
            filterable: true,
        },
        ...authoredColumns,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=messages-columns.js.map